/**
 * In-memory store for the per-session response-encryption key ("session key").
 *
 * The session key is the ONLY key used to decrypt API responses for the current
 * session. It is delivered once over TLS at login and is deliberately NOT
 * persisted anywhere (no localStorage / redux-persist / cookies) — it lives only
 * in memory for the lifetime of the page. After a page refresh the in-memory key
 * is lost and is restored from the backend via `restoreAdminSession`, which is
 * authorized by the httpOnly session cookie.
 */
let sessionKey: string | null = null;

export const setSessionKey = (key: string): void => {
    sessionKey = key;
};

export const getSessionKey = (): string | null => sessionKey;

export const clearSessionKey = (): void => {
    sessionKey = null;
};
